// Permission.js

export const getUserData = () => {
  try {
    return JSON.parse(
      localStorage.getItem("user_data") || "{}"
    );
  } catch (error) {
    console.error("Invalid user_data:", error);
    return {};
  }
};

export const getUserActions = () => {
  const userData = getUserData();

  let actions = userData?.actions || [];

  try {
    while (typeof actions === "string") {
      actions = JSON.parse(actions);
    }
  } catch (error) {
    console.error("Invalid staff actions:", error);
    return [];
  }

  if (!Array.isArray(actions)) {
    return [];
  }

  return actions
    .map((action) =>
      String(action).toLowerCase().trim()
    )
    .filter(Boolean);
};

export const hasPermission = (permission) => {
  const userData = getUserData();


  const role = localStorage.getItem('role');
 

  // Owner and Admin have full access
  if (role === "owner" || role === "admin") {
    return true;
  }

  // Staff must have the required action
  const actions = getUserActions();

  return actions.includes(
    String(permission).toLowerCase().trim()
  );
};
